<template>
    <div class="contenedor">
        <div v-if="loading">
            <loader></loader>
        </div>
        <b-row>
            <b-col sm="6">
                <span class="titulo">Producto A: <span class="productoNom">{{ producto1.nombre }}</span></span>
            </b-col>
            <b-col sm="6">
                <span class="titulo">Producto B: <span class="productoNom">{{ producto2.nombre }}</span></span>
            </b-col>
        </b-row>
        <b-row class="mt-2">               
            <b-col sm="6">              
                <b-form-group
                    class="UNformData"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="No UN:"
                    label-for="inputHorizontal">
                    <b-form-input 
                        v-model="producto1.noun" 
                        v-if="producto1.id === ''">
                    </b-form-input>
                    <span v-else>{{ producto1.noun }}</span>
                </b-form-group>
                <b-form-group
                    class="UNformData"
                    horizontal
                    :label-cols="4" 
                    breakpoint="md"
                    label="Peligro Principal:"
                    label-for="inputHorizontal">
                <b-form-select :options="optprincipal" 
                        v-model="producto1.riesgo_principal"
                        v-if="producto1.id === ''"/>
                    <span v-else>{{ producto1.riesgo_principal }}</span>
                </b-form-group>
                <b-form-group
                    class="UNformData"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Peligro Secundario:"
                    label-for="inputHorizontal">
                <b-form-select :options="optsecundario" 
                    v-model="producto1.riesgo_secundario"
                    v-if="producto1.id === ''"/>
                    <span v-else>{{ producto1.riesgo_secundario }}</span>
                </b-form-group>
                <b-form-group
                    class="UNformData"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Peligro Secundario 1:"
                    label-for="inputHorizontal">
                    <b-form-select  :options="optsecundario1" 
                        v-model="producto1.riesgo_secundario1"
                        v-if="producto1.id === ''"/>
                    <span v-else>{{ producto1.riesgo_secundario1 }}</span>
                </b-form-group>
            </b-col>
            <b-col sm="6">
                <b-form-group
                    class="UNformData"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="No UN:"
                    label-for="inputHorizontal">
                    <b-form-input 
                        v-model="producto2.noun"  
                        v-if="producto2.id === ''">
                    </b-form-input>
                    <span v-else>{{ producto2.noun }}</span>
                </b-form-group>
                <b-form-group
                    class="UNformData"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Peligro Principal:"
                    label-for="inputHorizontal">
                    <b-form-select 
                        :options="optprincipal" 
                        v-model="producto2.riesgo_principal"
                        v-if="producto2.id === ''"/>
                    <span v-else>{{ producto2.riesgo_principal }}</span>
                </b-form-group>
                <b-form-group
                    class="UNformData"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Peligro Secundario:"
                    label-for="inputHorizontal">
                    <b-form-select  
                        :options="optsecundario" 
                        v-model="producto2.riesgo_secundario"
                        v-if="producto2.id === ''"/>
                    <span v-else>{{ producto2.riesgo_secundario }}</span>
                </b-form-group>
                <b-form-group
                    class="UNformData"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Peligro Secundario 1:"
                    label-for="inputHorizontal">
                    <b-form-select 
                        :options="optsecundario1" 
                        v-model="producto2.riesgo_secundario1"
                        v-if="producto2.id === ''"/>
                    <span v-else>{{ producto2.riesgo_secundario1 }}</span>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="d-flex justify-content-between">                    
            <b-col sm="10">
                <b-button @click="regresarPaso" class="mr-2">
                    Anterior
                </b-button>
                <b-button @click="$emit('volverMatriz')">
                    Cancelar
                </b-button>
            </b-col>
            <b-col class="d-flex justify-content-end" sm="2">                        
                <b-button :disabled="validarNacionesUnidas()" variant="primary" @click="continuarPaso">
                    Siguiente
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex'
import loader from './../../containers/loader'

export default {
    name:'NacionesUnidas',
    props:['admin'],
    data(){
        return{
            loading: false,
            pasoActual: 1
        };
    },
    components: {
        loader
    },
    computed:{
       ...mapState('nacionesunidas', [
            'selectedUn',
            'txtprincipal',
            'txtsecundario',
            'txtsecundario1',
            'guiaRespuestaEmergencia',
            'dirRotulo',
            'rotul'
        ]),
        ...mapState('matrizCompatibilidad', [
            'producto1',
            'producto2',
            'optprincipal',
            'optsecundario',
            'optsecundario1'
        ])
    },
    methods:{
        regresarPaso() {
            this.resetUNProductos();
            this.setPaso(0);
        },
        async continuarPaso() {
            this.limpiarSga();
            this.load(true);
            // await this.getJsonSga();
            await this.getFrasesHSga();
            this.setPaso(2);
            this.load(false);
        },
        validarNacionesUnidas() {
            if (this.producto1.noun === '' || this.producto1.riesgo_principal === '' || this.producto1.riesgo_secundario === '' || this.producto1.riesgo_secundario1 === '') {
                return true;
            }

            if (this.producto2.noun === '' || this.producto2.riesgo_principal === '' || this.producto2.riesgo_secundario === '' || this.producto2.riesgo_secundario1 === '') {
                return true;
            }
            return false;
        },     
        ...mapActions('matrizCompatibilidad', [
            'getJsonSga'
        ]),
        ...mapActions('sga', [
            'getFrasesHSga'
        ]),
        ...mapMutations('dashboard', [
            'load'
        ]),
        ...mapMutations('matrizCompatibilidad', [
            'setModalMatriz',
            'setPaso',
            'resetUNProductos',
            'limpiarSga'
        ])        
    }
}
</script>
<style scoped>
.unPictograma{
  width: 100px;
  height: 100px;
}
.UNformData{
    display: flex;
    align-items: center;
}
.titulo {
    font-size: 13pt;
}
.productoNom {
    font-size: 11pt;
}
</style>
